export default __webpack_public_path__ + "static/media/IMG_0453-2.aafe27da.jpg";